import { render, staticRenderFns } from "./WtPagination.vue?vue&type=template&id=2735fd0e&scoped=true&lang=pug&"
import script from "./WtPagination.vue?vue&type=script&lang=js&"
export * from "./WtPagination.vue?vue&type=script&lang=js&"
import style0 from "./WtPagination.vue?vue&type=style&index=0&id=2735fd0e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2735fd0e",
  null
  
)

export default component.exports